export const COOKIE_CACHE_KEYS = {
  clientToken: 'tob_token',
  clientEntityId: 'WALLET_SESSION_ENTITY_ID',
  requestToken: 'shopee_tob_token',
  requestEntityId: 'shopee_tob_entity_id',
  requestMerchantId: 'shopee_foody_mid',
  requestFrom: 'shopee_request_from',
  sessionId: 'shopee_tob_session_id',
  pfb: 'SPC_PFB_FOODY_SELLER',
  entityId: 'currentStoreId',
}

export const APP_LOCAL_STORAGE_CACHE_KEYS = {
  APP_GUIDANCE_STATUS: 'app_guidance_status',
}
